import React from 'react'
import { Gesture } from 'react-with-gesture'
import { Spring, animated } from 'react-spring'
import { toast } from 'react-toastify'
import Moment from 'moment'

import snoozePerson from '../../actions/snoozePerson'
import createTouch from '../../actions/createTouch'
import colors from '../../styles/colors'
import {
  SwipeRowWrapper,
  SwipeRowActionsWrapper,
  SwipeRowAction,
} from '../../styles/lists'

const SWIPE_THRESHOLD = 20

class SwipeablePerson extends React.Component {
  state = {
    gesture_recognized: false
  }

  setTouchState = props => {
    this.setState({
      gesture_recognized: false
    })
    return props
  }

  checkForAction = props => {
    const { xDelta } = props

    if (Math.abs(xDelta) >= SWIPE_THRESHOLD && !this.state.gesture_recognized) {
      if (Math.sign(xDelta) > 0) {
        createTouch({personId: this.props.person.id})
          .then( () => toast(`Logged convo with ${this.props.person.name} today`))
      }
      if (Math.sign(xDelta) < 0) {
        snoozePerson(this.props.person.id, Moment().add(7, 'days').toDate())
          .then( () => toast(`Snoozed until 1 week from now`))  
      }
    } else {
      this.props.history.push(`/person/${this.props.person.id}`)
    }

    this.setState({
      gesture_recognized: true
    })

    return props
  }

  render() {
    return <Gesture onDown={this.setTouchState} onUp={this.checkForAction}>
      {({ down, xDelta }) => (
        <Spring native to={{ x: down ? xDelta : 0 }} immediate={name => down && name === 'x'}>
          {({ x }) => {
            return <SwipeRowWrapper style={{ backgroundColor: xDelta < 0 ? colors.orange : colors.green }}>
              <SwipeRowActionsWrapper>
                <SwipeRowAction left><ion-icon name="checkmark"></ion-icon> log convo</SwipeRowAction>
                <SwipeRowAction right><ion-icon name="time"></ion-icon> snooze</SwipeRowAction>
              </SwipeRowActionsWrapper>
              <animated.div style={{ transform: x.interpolate(x => `translate3d(${x}px,0,0)`)}}>
                {this.props.children}
              </animated.div>
            </SwipeRowWrapper>
          }}
        </Spring>
      )}
    </Gesture>
  }
}

export default SwipeablePerson



// WEBPACK FOOTER //
// ./src/views/people/SwipeablePerson.js